import 'styles/components/settings/inboxes/ManageInbox.styl'

import classnames from 'classnames'
import DeleteConfirmModal from 'components/settings/DeleteConfirmModal'
import withNotifications from 'components/shared/notifications'
import MakeInputChangeHandler from 'mixins/MakeInputChangeHandler'
import PropTypes from 'prop-types'
import Input from 'shared-web/src/components/Input'
import IconSVG from 'svg-inline-react'
import { newConversation } from 'utils/DrifttHelpers'
import * as Helpers from 'utils/Helpers'
import { isEmail } from 'validator'

import HelpModal from '../HelpModal'

const ManageInbox = React.createClass({
  contextTypes: {
    router: PropTypes.object.isRequired,
  },

  mixins: [MakeInputChangeHandler],

  getInitialState() {
    const { inbox, params, embed } = this.props

    const isNew = params.inboxId === 'new'
    return {
      name: !!inbox ? inbox.name : (isNew && (embed && embed.organizationName)) ? `${embed.organizationName}` : undefined,
      address: !!inbox ? inbox.address : undefined,
      showModal: false,
      isCreating: false,
      showDeleteModal: false,
    }
  },

  handleNewInbox(props) {
    const { inbox, params, embed } = props
    const isNew = params.inboxId === 'new'
    this.setState({
      name: !!inbox ? inbox.name : isNew ? `${embed.organizationName}` : undefined,
      address: !!inbox ? inbox.address : undefined,
      showModal: false,
      isCreating: false,
      showDeleteModal: false,
    })
  },

  getAddressInputError() {
    if (this.state.address) {
      if (!isEmail(this.state.address)) {
        return 'Sorry, that email is not valid.'
      } else if (this.isAddressTaken()) {
        return 'Email is taken!'
      }
    }
  },

  componentWillReceiveProps(nextProps) {
    if (!this.props.createdInboxId && nextProps.createdInboxId) {
      const path = `/settings/manage-inboxes/${nextProps.createdInboxId}`
      return this.context.router.push(path)
    }

    //handling going from not recieving an inbox from props and later getting one (for example, when clicking from main settings page)
    if (!this.props.inbox && nextProps.inbox && nextProps.inbox.id) {
      this.handleNewInbox(nextProps)

    } else if (this.props.inbox && (this.props.inbox.name != nextProps.inbox.name) || (this.props.inbox.address != nextProps.inbox.address)) {
      //handle patch requests
      this.handleNewInbox(nextProps)
    }

  },

  isAddressValid() {
    return isEmail(this.state.address) && !this.isAddressTaken()
  },

  isAddressTaken() {
    if (this.state.address !== (this.props.inbox != null ? this.props.inbox.address : undefined)) {
      return _.includes(_.map(this.props.inboxesById, 'address'), this.state.address)
    } else {
      return false
    }
  },

  isNameValid() {
    if (!this.state.name) {
      return false
    }
    if (this.isNew()) {
      return !this.isNameTaken()
    } else {
      return (
        this.state.name === (this.props.inbox != null ? this.props.inbox.name : undefined) ||
        !this.isNameTaken()
      )
    }
  },

  isNameTaken() {
    return _.includes(_.map(this.props.inboxesById, 'name'), this.state.name)
  },

  isNew() {
    return this.props.params.inboxId === 'new'
  },

  getNameInputError() {
    if (this.isNameTaken()) {
      return 'You already have an inbox with this name'
    }
  },

  renderForwardingInfo() {
    return (
      <div className={classnames('forward-container', { shown: !this.isNew() })}>
        <div className="forward-to-title">Forward your emails to the following address:</div>
        <div className="forward-address-container">
          <IconSVG src={require('!svg-inline?removeTags=true!images/icons/envelope-icon.svg')} />
          <div className="forward-to">
            {this.props.inbox != null ? this.props.inbox.forwardAddress : undefined}
          </div>
        </div>
        <div className="micro-copy">Emails forwarded to the above email address will appear as a conversation in this inbox. <a href="https://help.drift.com/article/inboxes-for-conversations" rel="noopener norefferer">Learn more</a></div>
      </div>
    )
  },

  renderInputs() {
    return (
      <div>
        <div className="inbox-name">
          <IconSVG
            className="inbox-icon"
            src={require('!svg-inline?removeTags=true!images/icons/envelope-icon.svg')}
          />
          <Input
            placeholder="Enter inbox name"
            autoFocus={this.isNew()}
            valueLink={{
              value: this.state.name,
              requestChange: this.makeInputChangeHandler('name'),
            }}
            isValid={this.isNameValid()}
            errorLabel={this.getNameInputError()}
          />
          <div className="micro-copy">
            This name will be seen by your visitors when you email them. Ours is named <em>Drift Support</em>.
          </div>
        </div>
        <div className="section-header">
          <div className="input-title">Public Email Address</div>
        </div>
        <div className="email-address">
          <IconSVG
            className="forward-to-icon"
            src={require('!svg-inline?removeTags=true!images/icons/forward-to-icon.svg')}
          />
          <Input
            placeholder="e.g support@company.com"
            valueLink={{
              value: this.state.address,
              requestChange: this.makeInputChangeHandler('address', this.onAddressInputChange),
            }}
            isValid={this.isAddressValid()}
            errorLabel={this.getAddressInputError()}
          />
          <div className="micro-copy">
            This is the address your visitors will get replies from. We recommend a generic address like{' '}
            <em>hello@{this.props.embed && this.props.embed.organizationUrl || 'drift.com'}</em>
          </div>
          <div className="micro-copy">
            Heads up! In order for messages to be sent from this email address, it needs to be associated with a <a href="/settings/dkim" rel="noopner norefferer"> specific email sending domain</a>. You can do this by updating its DNS records.
          </div>
        </div>
      </div>
    )
  },

  renderConfigSectionHeader(header, helpModalType, help) {
    if (help == null) {
      help = true
    }
    return (
      <div className="config-header">
        <div className="title-container">
          <div className="title">{header}</div>
          {help ? (
            <a className="help" onClick={() => this.setState({ showModal: helpModalType })}>
              Need help?
            </a>
          ) : (
              undefined
            )}
        </div>
        <div className="divider" />
      </div>
    )
  },

  getDomain() {
    return Helpers.getDomainFromEmail(this.props.inbox != null ? this.props.inbox.address : undefined)
  },

  onClickDeleteInbox() {
    return this.setState({ showDeleteModal: true })
  },

  onConfirmDelete() {
    this.props.actions.archiveInbox({ id: this.props.inbox.id })
    this.props.notifications.success(`Deleted inbox ${this.props.inbox.name}`)
    return this.context.router.replace('/settings2/conversations')
  },

  renderDeleteModal() {
    return (
      <DeleteConfirmModal
        title="Delete Inbox"
        onClose={() => this.setState({ showDeleteModal: false })}
        onConfirm={this.onConfirmDelete}
        confirmLabel="I understand, delete."
      >
        <div>
          <div className="text-section">
            You&#39;re about to delete the inbox &#39;
            <b>{this.props.inbox.name}</b>.&#39;

          </div>
          <div className="text-section">
            You&#39;ll lose access to messages in this inbox, and potentially miss new ones.
            We recommend chatting with us before deleting.
          </div>
          <div>
            <span className="link" onClick={newConversation}>Talk to us.</span>
          </div>
        </div>
      </DeleteConfirmModal>
    )
  },

  renderInboxSettings() {
    return (
      <div className="config-inbox-settings">
        {this.renderConfigSectionHeader('Forwarding', 'forward')}
        {this.renderForwardingInfo()}
        {Object.keys(this.props.inboxesById).length > 1 ? this.renderDangerZone() : undefined}
        {this.state.showDeleteModal ? this.renderDeleteModal() : undefined}
      </div>
    )
  },

  renderDangerZone() {
    return [
      this.renderConfigSectionHeader('Danger Zone', null, false),
      <button className="color-red btn-settings" onClick={this.onClickDeleteInbox}>
        Delete Inbox
      </button>,
    ]
  },

  onClickReset() {
    if (this.canSubmit()) {
      return this.setState(_.cloneDeep(this.getInitialState()))
    }
  },

  getSaveButtonText() {
    if (this.state.isCreating) {
      return 'Creating...'
    }
    if (this.isNew()) {
      return 'Create'
    } else {
      return 'Save'
    }
  },

  render() {
    return (
      <div className={classnames('ManageInbox', { 'move-back': this.state.movingBack })}>
        <div className="manage-inbox">
          <div>
            <a href="/settings2/conversations">&lt; Conversations Settings</a>
          </div>
          <div className="inbox-settings section">
            <div className="section-header">
              <div className="input-title">Inbox name</div>
            </div>
            {this.renderInputs()}
          </div>
          <div className={classnames('action-controls', { shown: this.canSubmit() })}>
            <button
              className={classnames('save disabled action btn-settings', {
                'color-teal': !this.state.isCreating,
              })}
              disabled={!this.canSubmit()}
              onClick={this.saveClicked}
            >
              {this.getSaveButtonText()}
            </button>
            <div className="reset" onClick={this.onClickReset}>
              Cancel
            </div>
          </div>
          {!this.isNew() ? this.renderInboxSettings() : undefined}
          {this.state.showModal ? (
            <HelpModal
              inbox={this.props.inbox}
              type={this.state.showModal}
              onClose={() => this.setState({ showModal: false })}
            />
          ) : (
              undefined
            )}
        </div>
      </div>
    )
  },

  hasChanged() {
    return (
      this.state.name !== (this.props.inbox != null ? this.props.inbox.name : undefined) ||
      this.state.address !== (this.props.inbox != null ? this.props.inbox.address : undefined)
    )
  },

  canSubmit() {
    return this.state.name && this.hasChanged() && this.isAddressValid() && this.isNameValid()
  },

  saveClicked() {
    if (this.canSubmit()) {
      if (this.isNew()) {
        this.setState({ isCreating: true })
        this.props.actions.createInbox({ name: this.state.name, address: this.state.address })
      } else {
        this.props.actions.patchInbox({
          id: this.props.inbox.id,
          name: this.state.name,
          address: this.state.address,
        })
      }
    }
  },


  onAddressInputChange(newAddress) {
    if (
      isEmail(newAddress) &&
      newAddress !== (this.props.inbox != null ? this.props.inbox.address : undefined)
    ) {
      return false
    }
  },
})

export default withNotifications(ManageInbox)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/inboxes/ManageInbox/component.js